import { createElement, Fragment, type ReactNode } from "react"
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Renders `**bold**` markdown-style segments as `<strong>`, everything else as plain text. */
export function renderWithStrong(text: string): ReactNode[] {
  return text.split(/(\*\*.*?\*\*)/g).map((chunk, index) => {
    if (chunk.startsWith("**") && chunk.endsWith("**")) {
      return createElement("strong", { key: `${chunk}-${index}` }, chunk.slice(2, -2));
    }
    return createElement(Fragment, { key: `${chunk}-${index}` }, chunk);
  });
}
